import React, { useState } from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx, useWidgetActions } from '../LayoutContext';
import { TasksTab } from '../../CaseClient';

// Granular Case-surface widget — wraps the existing TasksTab. Renders the
// task progress list + the discretionary launch palette. Forwards the
// case row from layout ctx and pipes "Open step" clicks back through the
// host onOpenWorkItem callback so opening a step still hops to the
// Work Item tab in the MDI shell.

function CaseTasks({ node }) {
  const { token, workspaceId, currentUser, case: caseRow, callbacks, bus } = useLayoutCtx();
  // Re-mount key — `refresh` action bumps it, which forces TasksTab to throw
  // away its internal data fetch and reload. Cheaper than threading an
  // imperative ref through every wrapped tab.
  const [refreshKey, setRefreshKey] = useState(0);
  useWidgetActions(node?.id, { refresh: () => setRefreshKey(k => k + 1) });

  if (!caseRow?.id) return null;
  const handleOpen = (workItemId, stepName) => {
    if (callbacks && typeof callbacks.onOpenWorkItem === 'function') {
      callbacks.onOpenWorkItem(
        { id: workItemId, step_name: stepName },
        { id: caseRow.id, case_number: caseRow.case_number, title: caseRow.title },
      );
    }
    if (bus && typeof bus.publish === 'function') {
      bus.publish('xv.OpenWorkItem', { workItemId, stepName, caseId: caseRow.id });
    }
  };
  return (
    <div style={{ padding: '20px' }}>
      <TasksTab
        key={refreshKey}
        token={token}
        workspaceId={workspaceId}
        caseId={caseRow.id}
        currentUser={currentUser}
        onWorkItemOpen={handleOpen}
      />
    </div>
  );
}

registerWidget({
  type: 'case.tasks',
  categories: ['case'],
  palette_label: 'Case tasks',
  description: 'Active tasks + discretionary launch palette for the open case. Clicking "Open step" opens the work item.',
  Component: CaseTasks,
  configSchema: null,
  publishes: ['xv.OpenWorkItem', 'xv.TaskLaunched'],
  subscribes: ['xv.RefreshContext'],
  actions: [
    { name: 'refresh', label: 'Reload tasks', description: 'Re-fetches the case task list and discretionary launch palette.' },
  ],
  group: 'Case',
});
